// extracted by mini-css-extract-plugin
export default {"startChatButton":"startchatbutton_startChatButton__nqcDr","container":"startchatbutton_container__SwN+m"};